import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type ICianApiSiteV1GetRegionCitiesRequest,
  type ICianApiSiteV1GetRegionCitiesResponse,
  fetchCianApiSiteV1GetRegionCities,
} from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-region-cities';

export const fetchGetCities = withTypeSafeApiResult<
  ICianApiSiteV1GetRegionCitiesRequest,
  ICianApiSiteV1GetRegionCitiesResponse
>(fetchCianApiSiteV1GetRegionCities);
